/** 8 MB */
export const MAX_FILE_SIZE = 8 * 1000 * 1000
